import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { Theme, ThemeService } from '../services/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bepatient-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  standalone: false
})
export class ThemeSwitcherComponent implements OnInit, OnDestroy {
  private themeService = inject(ThemeService);

  @Input() isTopRight = false;
  isDarkMode = false;
  private themeSubscription: Subscription;

  ngOnInit(): void {
    // Get the current theme and set isDarkMode accordingly
    const currentTheme = this.themeService.getCurrentTheme();
    this.isDarkMode = currentTheme === Theme.DARK;

    // Subscribe to theme changes
    this.themeSubscription = this.themeService.getTheme().subscribe(theme => {
      this.isDarkMode = theme === Theme.DARK;
    });
  }

  /**
   * Toggle the theme between light and dark modes
   */
  onThemeToggle(): void {
    const newTheme = this.isDarkMode ? Theme.LIGHT : Theme.DARK;
    this.themeService.setTheme(newTheme);
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
  }
}
